export const getDomElements = section => {
	const chamberId = document.getElementById('chamberOfCommerceId');

	return {
		vatIncl: section.querySelector('#vatIncl'),
		vatExcl: section.querySelector('#vatExcl'),
		taxNumber: section.querySelector('#companyTaxNumber'),
		taxNumberVatInput: section.querySelector('#taxNumberVatInput'),
		chamberId,
		chamberInputWrapper: chamberId?.closest('.form-group'),
		translations: document.getElementById('chamberOfCommerceTranslations'),
	};
};

export default function peppolBillingSection(section) {
	if (!section) return;

	document.addEventListener('DOMContentLoaded', () => {
		const dom = getDomElements(section);

		if (!dom.taxNumber || !dom.chamberId) {
			return;
		}

		const vatPrefix = section.dataset.vatPrefix || '';
		const syncTaxNumber = () => {
			dom.taxNumber.value = `${vatPrefix}${dom.chamberId.value}`;
		};

		syncTaxNumber();

		let formValidator = null;
		const FormControl = window?.od?.FormControl;
		const form = section.closest('form');

		if (form && typeof FormControl === 'function') {
			formValidator = new FormControl(form);
		}

		const handleVatChange = target => {
			const isMandatory = target.value === 'yes';

			if (dom.chamberInputWrapper) {
				dom.chamberInputWrapper.classList.toggle(
					'form-inline-row--is-mandatory',
					isMandatory,
				);
			}
			dom.taxNumberVatInput?.toggleAttribute('hidden', !isMandatory);
			dom.taxNumber.name = isMandatory ? 'companyTaxNumber' : '';

			if (formValidator?.rules) {
				const fieldRules =
					formValidator.rules[dom.chamberId.name] ||
					(formValidator.rules[dom.chamberId.name] = {});

				if (isMandatory && dom.translations) {
					fieldRules.required = {
						rule: true,
						message: dom.translations.dataset.msgRequired,
					};
				} else {
					delete fieldRules.required;
				}
			}
		};

		if (dom.vatIncl?.checked) {
			handleVatChange(dom.vatIncl);
		} else if (dom.vatExcl?.checked) {
			handleVatChange(dom.vatExcl);
		}

		dom.vatIncl?.addEventListener('change', e => handleVatChange(e.target));
		dom.vatExcl?.addEventListener('change', e => handleVatChange(e.target));

		dom.chamberId.addEventListener('input', syncTaxNumber);
	});
}
